export const url = {
  1: { url: 'six', series: 1 },
  2: { url: 'racing', series: 2 },
  3: { url: 'cqssc', series: 2 },
  4: { url: 'xync', series: 2 },
  5: { url: 'xyft', series: 2 },
  6: { url: 'gdklsf', series: 2 },
  8: { url: 'bjkt', series: 2 },
  9: { url: 'syssix', series: 3 },
  10: { url: 'jsssc', series: 3 },
  11: { url: 'jssc', series: 3 },
  12: { url: 'jsft', series: 3 },
  13: { url: 'jsnc', series: 3 },
  14: { url: 'twdlt', series: 1 },
  15: { url: 'xjpdd', series: 1 },
  16: { url: 'sesix', series: 3 },
  17: { url: 'txffc', series: 2 },
  18: { url: 'gcsyssix', series: 4 },
  19: { url: 'gcjsssc', series: 4 },
  20: { url: 'gcjssc', series: 4 },
  21: { url: 'gcjsft', series: 4 },
  22: { url: 'gcjsnc', series: 4 },
  23: { url: 'gcsix', series: 4 },
  24: { url: 'seffsix', series: 3 },
  25: { url: 'seffc', series: 3 },
  26: { url: 'seffsc', series: 3 },
  27: { url: 'seffsft', series: 3 },
  28: { url: 'seffnc', series: 3 },
  29: { url: 'gcffsix', series: 4 },
  30: { url: 'gcffc', series: 4 },
  31: { url: 'gcffsc', series: 4 },
  32: { url: 'gcffsft', series: 4 },
  33: { url: 'gcffnc', series: 4 },
}
// 官方低采：1
// 官方高采：2
// 12急速,自开高采：3
// gc急速,自开高采：4
